import { Flag } from "./lawyerFlag";
import { CloseIcon } from "./v2/icons";

// Row of active filter chips with individual remove + "Clear all". Rendered on
// both desktop and mobile. Presentation rebuilt 1:1 from the V2 handoff
// (boards 1b/1c): chip = "Label: [flag] Value" in #EBF3FF/#C9E1FF/#1567D2 with
// an 11×11 close-X (w2.5); "Clear all" link 12.5px #2283FF semibold. The
// result count (board 1b right side) renders via `rightSlot`, provided by the
// page so this component keeps its single job. Per-chip remove →
// onRemove(key, value); the country filter is multi-select (follow-up pack
// A2) and renders ONE chip PER selected country, each removable on its own —
// with one country selected this is exactly the old single chip. "Clear all"
// → onReset (resetFilters). `jurisdictionFlags` maps a jurisdiction value to
// its resolved { code, label } for the flag on the country chips.
const LawyerActiveFilters = ({
  filters,
  onRemove,
  onReset,
  jurisdictionFlags = {},
  rightSlot = null,
  t = (s) => s,
}) => {
  const chips = [
    // One chip per selected country (multi-select, A2)
    ...(Array.isArray(filters.jurisdiction) ? filters.jurisdiction : []).map(
      (country) => ({
        key: "jurisdiction",
        label: t("Country"),
        value: country,
        flag: jurisdictionFlags[country],
      })
    ),
    filters.specialization && {
      key: "specialization",
      label: t("Specialization"),
      value: filters.specialization,
    },
    filters.language && {
      key: "language",
      label: t("Language"),
      value: filters.language,
    },
    filters.city && { key: "city", label: t("City"), value: filters.city },
  ].filter(Boolean);

  if (chips.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {chips.map((chip) => (
        <span
          key={`${chip.key}:${chip.value}`}
          className="inline-flex items-center gap-1.5 whitespace-nowrap px-[11px] py-[5px] rounded-full bg-[#EBF3FF] border border-[#C9E1FF] text-[#1567D2] text-[12px] font-semibold"
        >
          <span className="truncate max-w-[12rem] inline-flex items-center gap-1.5">
            {chip.label}:{" "}
            {chip.flag?.code && (
              <Flag {...chip.flag} width={16} height={11} />
            )}
            {chip.flag?.label || chip.value}
          </span>
          <button
            type="button"
            onClick={() => onRemove(chip.key, chip.value)}
            className="p-0.5 -mr-0.5 rounded-full hover:bg-[#D3E5FD] text-[#1567D2]"
            aria-label={`${t("Remove")} ${chip.value}`}
          >
            <CloseIcon size={11} strokeWidth={2.5} />
          </button>
        </span>
      ))}
      <button
        type="button"
        onClick={onReset}
        className="ml-1 text-[12.5px] text-[#2283FF] font-semibold hover:text-[#1570E8]"
      >
        {t("Clear all")}
      </button>
      {rightSlot && <span className="ml-auto">{rightSlot}</span>}
    </div>
  );
};

export default LawyerActiveFilters;
